import i18n from '@shared/config/i18n';
import { toEditToken, ChildBase, toReadonlyToken, invocesToken } from '../defaults';
import { saveButton } from './saveButton';

const { t } = i18n;

export const actions: ChildBase = {
  spec: 'controls-horizontal',
  token: 'actions-horizontal',
  data: {},
  child: [
    {
      spec: 'button-text',
      token: toEditToken,
      data: {
        label: t('edit')!,
        visible: false,
        customData: {
          buttonText: {
            startIcon: 'EditOutlined',
            variantMui: 'outlined',
          },
        },
      },
      meta: {
        triggers: [
          {
            events: ['on-click'],
            targets: [toEditToken],
            handlers: ['set-not-readonly', 'set-delete-icon-buttons-visible'],
          },
        ],
        actions: [
          {
            kind: 'changes',
            token: 'set-not-readonly',
            spec: {
              target: invocesToken,
              changes: {
                'data.readOnly': {
                  type: 'val',
                  value: false,
                },
              },
            },
          },

          {
            kind: 'func',
            token: 'set-delete-icon-buttons-visible',
            spec: {
              func: `({hashMap, set, source, setSduiSource}) => {
  Object.values(hashMap).forEach(componentData => {
    if (componentData.token.indexOf('_delete-button-icon') === -1) return

    set(componentData, 'data.visible', true)
  })

  setSduiSource({source, add: true})
}`,
            },
          },
        ],
      },
    },

    {
      spec: 'button-text',
      token: toReadonlyToken,
      data: {
        label: t('cancel')!,
        visible: false,
        customData: {
          buttonText: {
            startIcon: 'Close',
            variantMui: 'outlined',
          },
        },
      },
      meta: {
        triggers: [
          {
            events: ['on-click'],
            targets: [toReadonlyToken],
            handlers: [
              'set-readonly',

              'load-invoces-list',
              'add-invoces-pending',

              'set-delete-icon-buttons-not-visible',
            ],
          },
          {
            events: ['data-fetch-success'],
            targets: [toReadonlyToken],
            handlers: ['subtract-invoces-pending', 'set-loaded-payment-types-list'],
            expr: {
              type: 'func',
              value: `({sourceAction}) => sourceAction.token === 'load-payment-types-list'`,
            },
          },
          {
            events: ['data-fetch-success'],
            targets: [toReadonlyToken],
            handlers: [
              'clear-existed-invoces',
              'clear-new-invoces',
              'clear-deleted-invoces',
              'clear-market-orders',

              'subtract-invoces-pending',

              'set-loaded-invoces-list',

              'resolve-show-no-existed-invoces-text',
            ],
            expr: {
              type: 'func',
              value: `({sourceAction}) => sourceAction.token === 'load-invoces-list'`,
            },
          },
        ],
        actions: [
          {
            kind: 'changes',
            token: 'set-readonly',
            spec: {
              target: invocesToken,
              changes: {
                'data.readOnly': {
                  type: 'val',
                  value: true,
                },
              },
            },
          },

          {
            kind: 'func',
            token: 'set-delete-icon-buttons-not-visible',
            spec: {
              func: `({hashMap, set, source, setSduiSource}) => {
  Object.values(hashMap).forEach(componentData => {
    if (componentData.token.indexOf('_delete-button-icon') === -1) return

    set(componentData, 'data.visible', false)
  })

  setSduiSource({source, add: true})
}`,
            },
          },
        ],
      },
    },

    saveButton,
  ],
  styles: { display: 'flex', gap: '12px', padding: '24px' },
};
